module.exports = __webpack_public_path__ + "img/back.7de3c9d4.svg";